/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Einvoice_Auto_Failed_TitleInputs */

const vi_pos_einvoice_auto_failed_title = /** @type {(inputs: Pos_Einvoice_Auto_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa tự phát hành được hóa đơn`)
};

/**

* @param {Pos_Einvoice_Auto_Failed_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_einvoice_auto_failed_title = /** @type {((inputs?: Pos_Einvoice_Auto_Failed_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Einvoice_Auto_Failed_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_einvoice_auto_failed_title(inputs)
});